import { cn } from "../utils/helpers";
import { SvgProps } from "../utils/types";

export default function ChevronDownIcon({ className }: SvgProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={cn("size-3.5 shrink-0", className)}
        >
            <polyline points="6 9 12 15 18 9" />
        </svg>
    );
}
